/* eslint-disable react/jsx-no-literals -- Allow hard-coded translations for now */
'use client'

import { type JSX } from 'react'

import { ProductPriceExplainerSection } from '../ProductPriceExplainerSection'

export const ProductPriceExplainerContentIt = (): JSX.Element => {
  return (
    <div className="flex flex-col gap-6">
      <ProductPriceExplainerSection>
        <p>
          Attenzione: non si tratta di uno sconto. L&apos;importo mostrato come
          barrato è il prezzo di vendita al pubblico consigliato dal fornitore o
          dal produttore.
        </p>
        <p>
          Per i prodotti venduti e spediti da terze parti, il prezzo definito
          &quot;Prima era&quot; è il prezzo totale più basso applicato dal
          rispettivo fornitore del prodotto negli ultimi 30 giorni prima
          dell&apos;applicazione dello sconto.
        </p>
        <p>
          Per i prodotti venduti e spediti da terze parti, la riduzione del
          prezzo indicata si riferisce al prezzo definito come &quot;Prima
          era&quot;, ovvero il prezzo totale più basso degli ultimi 30 giorni.
        </p>
      </ProductPriceExplainerSection>
    </div>
  )
}
